/**
 * TITAN 延長保証 動的価格 (段階価格variant方式 / 非Plus)
 * v2.0 2026-06-02
 *
 * 仕組み:
 *  - 延長保証は「金額」1軸の価格帯variant(¥5,000〜¥101,000, ¥1,000刻み)を持つ別商品(handle: titan-warranty)。
 *  - 保証ラジオ(Globo)が選択されたら、走行中のPC総額 × 料率 を計算し、
 *    ¥1,000単位で切り上げて、対応する価格帯variantを特定する。
 *  - 表示: .titan-price-addon / 保証ラベル / .tg-cust__opt-price に計算額を出す。
 *  - カート投入: Globoが固定tier(¥5,000等)を投入した「後」、'titan:cart-added' イベントを購読して
 *    reconcileCart() でカート内の保証ラインを正しいtierに差し替える(/cart.js → /cart/change.js + /cart/add.js)。
 *
 *  ★重要: window.fetch / XMLHttpRequest は絶対に wrap しない。
 *    main-product.liquid の preorder dialog が window.fetch を乗っ取っているため、
 *    二重 wrap するとダイアログが固まる事故になる(2026-06-01に発生・ロールバック済み)。
 *
 *  料率: 新品BTO 2年=6% / 3年=12% (1年=無料)。丸め: ¥1,000切り上げ。
 *  PC総額の読み取りは .titan-price-main の textContent(オプション加算後の総額)を使う。
 */
(function () {
  'use strict';

  // 二重ロードガード: theme.liquid で読み込むが、万一どこかで重複読込されても
  // observe()/setInterval()/reconcile が二重に走らないようにする。
  if (window.__titanWarrantyLoaded) return;
  window.__titanWarrantyLoaded = true;

  // プランキー → 料率。新品BTO: '2' (2年) / '3' (3年)。
  var CONFIG = {
    rates: {
      '2': 0.06,
      '3': 0.12
    },
    roundUnit: 1000,                  // variant刻み = 切り上げ単位
    minTier: 5000,
    maxTier: 101000,
    // price(円) → 数値variant ID。productSetで作成した titan-warranty の価格帯variant。
    // ※価格帯/variantを作り直したら window.TITAN_WARRANTY_MAP (Liquid出力) で上書きされる。
    priceMap: {"5000":"49785952993520","6000":"49785953026288","7000":"49785953059056","8000":"49785953091824","9000":"49785953124592","10000":"49785953157360","11000":"49785953190128","12000":"49785953222896","13000":"49785953255664","14000":"49785953288432","15000":"49785953321200","16000":"49785953353968","17000":"49785953386736","18000":"49785953419504","19000":"49785953452272","20000":"49785953485040","21000":"49785953517808","22000":"49785953550576","23000":"49785953583344","24000":"49785953616112","25000":"49785953648880","26000":"49785953681648","27000":"49785953714416","28000":"49785953747184","29000":"49785953779952","30000":"49785953812720","31000":"49785953845488","32000":"49785953878256","33000":"49785953911024","34000":"49785953943792","35000":"49785953976560","36000":"49785954009328","37000":"49785954042096","38000":"49785954074864","39000":"49785954107632","40000":"49785954140400","41000":"49785954173168","42000":"49785954205936","43000":"49785954238704","44000":"49785954271472","45000":"49785954304240","46000":"49785954337008","47000":"49785954369776","48000":"49785954402544","49000":"49785954435312","50000":"49785954468080","51000":"49785954500848","52000":"49785954533616","53000":"49785954566384","54000":"49785954599152","55000":"49785954631920","56000":"49785954664688","57000":"49785954697456","58000":"49785954730224","59000":"49785954762992","60000":"49785954795760","61000":"49785954828528","62000":"50447574302960","63000":"50447574335728","64000":"50447575220464","65000":"50447574368496","66000":"50447574401264","67000":"50447574434032","68000":"50447574466800","69000":"50447574499568","70000":"50447574532336","71000":"50447574565104","72000":"50447574597872","73000":"50447574630640","74000":"50447574663408","75000":"50447575253232","76000":"50447574696176","77000":"50447575286000","78000":"50447574728944","79000":"50447574761712","80000":"50447575318768","81000":"50447574794480","82000":"50447574827248","83000":"50447575351536","84000":"50447574860016","85000":"50447574892784","86000":"50447575384304","87000":"50447574925552","88000":"50447574958320","89000":"50447575417072","90000":"50447574991088","91000":"50447575449840","92000":"50447575023856","93000":"50447575482608","94000":"50447575056624","95000":"50447575515376","96000":"50447575089392","97000":"50447575548144","98000":"50447575122160","99000":"50447575154928","100000":"50447575580912","101000":"50447575187696"},
    debug: false
  };

  // ハードコードマップを退避(Liquid出力が不完全だった時のフォールバック用)
  var HARDCODED_PRICE_MAP = CONFIG.priceMap;

  // Liquid出力のマップがあれば優先（variant再作成時に強い）。
  // ただし全tier(¥5,000〜¥101,000 ¥1,000刻み=97件)が揃っているか検証し、欠けていたらハードコードに戻す。
  if (window.TITAN_WARRANTY_MAP && typeof window.TITAN_WARRANTY_MAP === 'object') {
    var mapComplete = true;
    for (var _p = CONFIG.minTier; _p <= CONFIG.maxTier; _p += CONFIG.roundUnit) {
      if (!window.TITAN_WARRANTY_MAP[String(_p)]) { mapComplete = false; break; }
    }
    if (mapComplete) {
      CONFIG.priceMap = window.TITAN_WARRANTY_MAP;
    } else {
      try { console.warn('[TITAN-Warranty] TITAN_WARRANTY_MAP が不完全。ハードコードマップにフォールバック'); } catch (e) {}
      CONFIG.priceMap = HARDCODED_PRICE_MAP;
    }
  }

  function log() { if (CONFIG.debug) console.log.apply(console, ['[TITAN-Warranty]'].concat([].slice.call(arguments))); }

  function ceilTo(n, unit) { return Math.ceil(n / unit) * unit; }

  // 走行中のPC総額(円)を読む。.titan-price-main の表示(オプション加算後)を優先。
  function readRunningTotal() {
    var mainEl = document.querySelector('.titan-price-main');
    if (mainEl) {
      var t = (mainEl.textContent || '').replace(/[^\d]/g, '');
      var n = parseInt(t, 10);
      if (!isNaN(n) && n > 0) return n;
    }
    // フォールバック: data-price-cents
    var pc = document.querySelector('[data-price-cents]');
    if (pc) {
      var c = parseInt(pc.getAttribute('data-price-cents'), 10);
      if (!isNaN(c) && c > 0) return Math.round(c / 100);
    }
    return 0;
  }

  // 保証オプション(Globo radio/checkbox)を取得。
  // TITANのGloboは gpo-data-product-handle 属性を持たないため、value/labelテキストで判定する。
  // 「保証」を含む radio/checkbox を保証オプションとみなす。
  function labelTextOf(cb) {
    var label = (cb.id && document.querySelector('label[for="' + cb.id + '"]')) || (cb.closest && cb.closest('label'));
    return label ? (label.textContent || '') : '';
  }
  function warrantyTextOf(cb) {
    return (cb.getAttribute('value') || '') + ' ' + labelTextOf(cb);
  }
  function getWarrantyCheckboxes() {
    var all = document.querySelectorAll('input[type="radio"], input[type="checkbox"]');
    var result = [];
    [].forEach.call(all, function (cb) {
      if (/保証|warranty/i.test(warrantyTextOf(cb))) result.push(cb);
    });
    return result;
  }

  // value/label からプラン年数(2/3)を判定。1年 or それ以外=無料(1)。
  function planYearsOf(cb) {
    var t = warrantyTextOf(cb);
    if (/3\s*年/.test(t)) return '3';
    if (/2\s*年/.test(t)) return '2';
    return '1'; // 1年(無料)
  }

  function planKeyOf(cb) {
    return planYearsOf(cb);
  }

  function isFreePlanKey(key) {
    return key === '1';
  }

  function warrantyYearsLabel(key) {
    if (key === '3' || key === 3) return '3年（標準1年＋追加2年）';
    if (key === '2' || key === 2) return '2年（標準1年＋追加1年）';
    return '延長保証';
  }

  // 計算: 総額 × 料率 → ¥1,000切り上げ → クランプ。0なら無料。
  function calcWarrantyAmount(total, planKey) {
    var rate = CONFIG.rates[planKey] || 0;
    if (rate <= 0 || total <= 0) return 0;
    var amt = ceilTo(total * rate, CONFIG.roundUnit);
    if (amt < CONFIG.minTier) amt = CONFIG.minTier;
    if (amt > CONFIG.maxTier) {
      // 上限tier超過 = 過小請求になる。debug無関係で必ず警告を出す。
      // 恒久対策は titan-warranty 商品に上位tier variant を追加して priceMap/maxTier を拡張すること。
      try {
        console.warn('[TITAN-Warranty] 上限tier超過で過小請求の可能性:', {
          total: total, planKey: planKey, rate: rate, calculated: amt, clampedTo: CONFIG.maxTier, undercharge: amt - CONFIG.maxTier
        });
      } catch (e) {}
      amt = CONFIG.maxTier;
    }
    return amt;
  }

  // 金額 → 価格帯variant ID
  function variantForAmount(amt) {
    return CONFIG.priceMap[String(amt)] || null;
  }

  function formatYen(n) { return '¥' + n.toLocaleString('ja-JP'); }

  // カート小計テキスト用フォーマッタ。
  //   Liquid側 main-cart-footer.liquid / cart-drawer.liquid は
  //   `{{ cart.total_price | money_without_currency | remove: '.00' }}円` で
  //   「168,000円」形式を出す(cart.total_price は cents)。これに一致させる。
  function formatCartTotalText(cents) {
    var yen = Math.round((Number(cents) || 0) / 100);
    return yen.toLocaleString('ja-JP') + '円';
  }

  // reconcile/数量変更後に Section Rendering API の .js-contents 空スキップで
  //   小計表示(.totals__total-value)が古いまま残るケースの最終保険。
  //   /cart.js の確定 total_price をカート画面 footer / ドロワーの両方に直接書き込む。
  //   Section Rendering API の成否に依存せず必ず最新化する。
  function syncCartTotalText(totalPriceCents) {
    if (typeof totalPriceCents !== 'number' || isNaN(totalPriceCents)) return;
    var text = formatCartTotalText(totalPriceCents);
    var nodes = document.querySelectorAll('.totals__total-value');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].textContent !== text) nodes[i].textContent = text;
    }
  }

  // 現在ON中の保証から「合計保証額」と「投入すべきvariant ID」を返す
  function currentWarrantySelection() {
    var total = readRunningTotal();
    var cbs = getWarrantyCheckboxes();
    var checked = cbs.filter(function (cb) { return cb.checked; });
    if (checked.length === 0) return { amount: 0, variantId: null, years: null, total: total };
    // 保証は排他想定だが、複数ONなら最後を採用
    var cb = checked[checked.length - 1];
    var planKey = planKeyOf(cb);
    var amount = calcWarrantyAmount(total, planKey);
    // 後方互換: 既存コードは sel.years を参照する箇所が多いため years エイリアスを残す。
    return { amount: amount, variantId: variantForAmount(amount), years: planKey, total: total };
  }

  // ---- 表示更新 ----
  function updateDisplay() {
    var sel = currentWarrantySelection();
    // 商品ページ価格の「＋延長保証 ¥XX,XXX」専用行は出さない(他オプションと同じ扱いにする)。
    // 保証額はスティッキー合計・ドロワー・カートで反映済み。価格ブロックには専用表示しない。
    var addonEl = document.querySelector('.titan-price-addon');
    if (addonEl) { addonEl.textContent = ''; addonEl.setAttribute('hidden', ''); }
    // 各保証ラジオのラベルに「正しい計算額」を出す。
    // Globoが出す固定額(.addOn「+5,000円」=紐付けvariantの素価格)は誤解を招くので消す。
    getWarrantyCheckboxes().forEach(function (cb) {
      var planKey = planKeyOf(cb);
      var amt = calcWarrantyAmount(readRunningTotal(), planKey);
      var label = document.querySelector('label[for="' + cb.id + '"]') || cb.closest('label') || (cb.parentElement);
      if (!label) return;
      // Globoの固定額表示(.addOn)を消す（+5,000円 などの素variant価格）
      var globoAddon = label.querySelector('.addOn');
      if (globoAddon) globoAddon.textContent = '';
      var span = label.querySelector('.titan-warranty-amt');
      if (isFreePlanKey(planKey)) { if (span) span.textContent = ''; return; }
      if (!span) {
        span = document.createElement('span');
        span.className = 'titan-warranty-amt';
        span.style.cssText = 'margin-left:6px;color:#c0392b;font-weight:700;';
        var valSpan = label.querySelector('.choicelist-item__value') || label;
        valSpan.appendChild(span);
      }
      span.textContent = '＋' + formatYen(amt);
    });
    // TITANカスタマイズUI(.tg-cust__opt)の右端金額欄(.tg-cust__opt-price)も更新する。
    // Globo radioとは別にこのUIが「0円」を出しているため、計算額に上書きする。
    var total = readRunningTotal();
    document.querySelectorAll('.tg-cust__opt').forEach(function (opt) {
      var txt = (opt.textContent || '');
      if (!/保証/.test(txt)) return;
      var priceEl = opt.querySelector('.tg-cust__opt-price');
      if (!priceEl) return;
      var planKey = /3\s*年/.test(txt) ? '3'
                  : (/2\s*年/.test(txt) ? '2' : '1');
      if (isFreePlanKey(planKey)) {
        priceEl.textContent = '0円';
        priceEl.classList.add('tg-cust__opt-price--free');
        return;
      }
      var amt = calcWarrantyAmount(total, planKey);
      priceEl.textContent = '＋' + formatYen(amt);
      priceEl.classList.remove('tg-cust__opt-price--free');
    });
    log('display updated', sel);
    var prev = window.__titanWarranty;
    window.__titanWarranty = sel; // ドロワー/カスタムUIが参照
    // 保証額が変わったら通知する。スティッキーバー(構成中の合計)とドロワーが購読して
    // 保証込みの合計に追従する。amount変化時のみ発火(無駄な再描画を避ける)。
    if (!prev || prev.amount !== sel.amount || prev.years !== sel.years) {
      // 保証選択が変わった → カートはまだ希望と不一致の可能性。clean を倒して
      // checkout手前ガードに「reconcile完了まで待て」と知らせる。
      window.__titanWarrantyReconcileClean = false;
      try { document.dispatchEvent(new CustomEvent('titan:cart-warranty-updated')); } catch (e) {}
    }
    // 商品ページで保証が選択されている時だけ、希望tierを保存(カートページreconcileの保険用)。
    // 別商品のstale値を誤適用しないよう product handle と総額(ts)も保存し、desiredWarranty で照合する。
    try {
      if (sel.total > 0 && sel.variantId) {
        sessionStorage.setItem('titanWarrantyWanted', JSON.stringify({
          variantId: sel.variantId, amount: sel.amount, years: sel.years, ts: sel.total, handle: currentProductHandle()
        }));
      } else if (sel.total > 0 && sel.years === null) {
        // 商品ページで保証OFF → 希望クリア
        sessionStorage.removeItem('titanWarrantyWanted');
      }
    } catch (e) {}
    // 動的決済(Shop Pay等)はカート/Globoの保証ラインをバイパスして本体だけ即決済するため、
    // 保証選択中(amount>0)は商品ページの動的決済ボタンを隠し、通常のカートフローに誘導する。
    // (保証なしの時は元に戻す)
    try {
      if (sel.total > 0) { // 商品ページのみ
        var dyn = document.querySelectorAll('.shopify-payment-button, .product-form__dynamic-checkout, [data-shopify="payment-button"]');
        [].forEach.call(dyn, function (el) {
          if (sel.amount > 0) {
            if (!el.hasAttribute('data-titan-dyn-hidden')) {
              el.setAttribute('data-titan-dyn-hidden', el.style.display || '');
            }
            el.style.display = 'none';
          } else if (el.hasAttribute('data-titan-dyn-hidden')) {
            el.style.display = el.getAttribute('data-titan-dyn-hidden');
            el.removeAttribute('data-titan-dyn-hidden');
          }
        });
      }
    } catch (e) {}
    // 構成オプションの差額マップを保存(カートで「+¥15,000」表示用)。
    // Globoは差額をカートに渡さないが、商品ページの選択肢ラベルに「+15,000円」が入っているので
    // 選択中オプションの「値→差額」を集めて sessionStorage に保存。カート側で property値と照合する。
    if (sel.total > 0) { saveOptionPriceMap(); }
  }

  // 商品ページの Globo 選択中オプションから「選択値 → 差額(円)」マップを作り保存する。
  // ラベル例: "DDR4 32GB+15,000円" / "Ryzen 7 7700+40,000円"。差額はラベル末尾の「+N円」から取る。
  function saveOptionPriceMap() {
    try {
      var map = {};
      var checked = document.querySelectorAll('.gpo-element input[type="radio"]:checked, .gpo-element input[type="checkbox"]:checked');
      [].forEach.call(checked, function (cb) {
        var val = (cb.getAttribute('value') || '').trim();
        if (!val) return;
        // 差額: data-addon-price 優先(ゼロ埋め6桁あり)、無ければラベルから「+N,NNN円」をパース
        var addon = 0;
        var raw = cb.getAttribute('data-addon-price');
        if (raw != null && raw !== '') {
          addon = parseInt(String(raw).replace(/[^\d]/g, ''), 10) || 0;
        } else {
          var label = (cb.id && document.querySelector('label[for="' + cb.id + '"]')) || (cb.closest && cb.closest('label'));
          var lt = label ? (label.textContent || '') : '';
          var m = lt.match(/\+\s*([\d,]+)\s*円/);
          if (m) addon = parseInt(m[1].replace(/,/g, ''), 10) || 0;
        }
        if (val && addon > 0) map[val] = addon;
      });
      sessionStorage.setItem('titanOptPriceMap', JSON.stringify({ handle: currentProductHandle(), map: map }));
    } catch (e) {}
  }

  // 現在の商品ページの handle を URL から取る(/products/<handle>)。商品ページでなければ null。
  function currentProductHandle() {
    var m = (location.pathname || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  // reconcile用の「希望保証選択」を取得。
  // 商品ページ(総額が読める)なら現在の選択、それ以外(カートページ等)なら保存値を使う。
  function desiredWarranty() {
    var total = readRunningTotal();
    if (total > 0) {
      // 商品ページ: 現在の選択が真実
      return currentWarrantySelection();
    }
    // ★過小/過大請求バグ修正(2026-06-04):
    //   カートページ(/cart)では sessionStorage の希望保証を信用してはいけない。
    //   sessionStorage の値は「最後に保証を選んだ商品ページ」の値で、カートに入っている
    //   本体PCとは別商品の可能性がある(例: RTX5060ページで保証¥18,000選択→離脱→
    //   別途RTX5080をカート投入→/cartで reconcile すると stale な¥18,000が誤適用される)。
    //   さらに /cart では currentProductHandle()=null のため handle 照合(下)が機能せず
    //   stale 判定をすり抜ける。→ カートページでは常に noContext を返し、reconcile側の
    //   cartDerivedDesired()(カート自身の本体total×rateで正tier算出)に委ねる。
    var isCartPage = /\/cart(\?|$|\/)/.test(location.pathname);
    if (isCartPage) {
      return { amount: 0, variantId: null, years: null, total: 0, noContext: true };
    }
    // 商品ページ以外かつカートページでもない(ドロワー等): 保存された希望を使う。
    try {
      var raw = sessionStorage.getItem('titanWarrantyWanted');
      if (raw) {
        var w = JSON.parse(raw);
        // 別商品ページ上で読んだ場合、保存値のhandleと現ページのhandleが食い違う = stale → 採用しない
        var hereHandle = currentProductHandle();
        if (w && w.handle && hereHandle && w.handle !== hereHandle) {
          return { amount: 0, variantId: null, years: null, total: 0, noContext: true };
        }
        if (w && w.variantId) return { amount: w.amount, variantId: w.variantId, years: w.years, total: w.ts || 0, fromStore: true };
      }
    } catch (e) {}
    return { amount: 0, variantId: null, years: null, total: 0, noContext: true };
  }

  function planKeyFromLabel(label) {
    var t = String(label || '');
    if (/3\s*年/.test(t)) return '3';
    if (/2\s*年/.test(t)) return '2';
    return null;
  }


  // ★過小請求の最終防波堤(2026-06-04):
  //   カートページで sessionStorage(titanWarrantyWanted)が空/stale だと desiredWarranty() が
  //   noContext を返し、Globoの誤tier(¥5,000)保証がそのまま checkout へ抜けて過小請求になる。
  //   その場合でも「カート自身の状態」から正tierを再計算する。sessionStorage に一切依存しない。
  //   - 本体PC総額 = 非保証ライン(final_line_price合計, cents→円)。
  //   - プラン年数 = 既存保証ラインの properties['保証年数'] ラベルから復元。
  //   復元できれば calcWarrantyAmount で正tierを得る。できなければ null(=従来どおり保守的に放置)。
  // 本体PC行1つから「その本体行の延長保証プランキー」を復元する。
  //   優先: 本体行 props['延長保証'](Globoが本体に焼き込む構成ラベル)。
  //   フォールバック: 値に年/月+保証 を含む他キー(キー名揺れ対策、_gpo_* は除外)。
  function planKeyFromBodyItem(it) {
    var props = (it && it.properties) || {};
    var label = props['延長保証'] || props['保証'] || props['warranty'] || '';
    if (!label) {
      Object.keys(props).forEach(function (k) {
        if (label) return;
        if (k.indexOf('_') === 0) return;
        if (/保証|warranty/i.test(k) || /保証|warranty/i.test(String(props[k]))) {
          if (/[0-9０-９]\s*[年か月ヶ]/.test(String(props[k]))) label = String(props[k]);
        }
      });
    }
    return planKeyFromLabel(label);
  }

  // 本体PC行1台あたりの単価(円)。final_line_price は qty 込みの行合計(cents)なので
  // quantity で割って1台単価に戻す(qty統合された本体への保険)。
  function perUnitYen(it) {
    var lineCents = (typeof it.final_line_price === 'number') ? it.final_line_price
                  : (typeof it.line_price === 'number') ? it.line_price
                  : ((it.final_price || it.price || 0) * (it.quantity || 1));
    var qty = it.quantity || 1;
    return Math.round((lineCents / qty) / 100);
  }

  // ★複数本体対応(2026-06-04):
  //   カート内の各本体PC行について「その本体の単価 × プラン料率」で個別正tierを算出し、
  //   本体台数分の希望保証(variantId)を集計して返す。単一本体は1件になり後方互換。
  //   返り値: {
  //     perBody: [{ variantId, amount, years, qty }...],   // 本体ごと(同variantは集約せず台数分)
  //     wantMap: { variantId(num): qty },                  // 希望「variant→必要qty」
  //     unresolvedBodies: n,                               // プラン復元できなかった保証対象本体数
  //     fromCart: true
  //   }
  //   保証対象 = BTO新品本体(プランキーが復元できた行)。プラン不明な保証ありそうな本体は
  //   unresolvedBodies に計上し、呼び出し側が過小請求防止のため checkout をブロックする。
  function cartDerivedDesired(cart, wset) {
    try {
      if (!cart || !cart.items) return null;
      var nonWarrantyLines = cart.items.filter(function (it) { return !wset[it.variant_id]; });
      if (nonWarrantyLines.length === 0) return null;

      var perBody = [];
      var wantMap = {};
      var unresolvedBodies = 0;

      nonWarrantyLines.forEach(function (it) {
        var bodyQty = it.quantity || 1;
        var planKey = planKeyFromBodyItem(it);
        // プランキーが復元できない本体 = 保証希望が無い(=保証未選択の本体)とみなして対象外。
        //   ただし「保証ラインが現存するのに本体のプランが読めない」ケースは呼び出し側で
        //   別途 unresolved 判定する(ここでは本体行自身の情報だけで判断)。
        if (!planKey) return;
        if (isFreePlanKey(planKey)) return; // 無料プラン(1年/1か月)は保証ライン不要
        var unit = perUnitYen(it);
        if (!(unit > 0)) { unresolvedBodies += bodyQty; return; }
        var amount = calcWarrantyAmount(unit, planKey);
        var variantId = variantForAmount(amount);
        if (!variantId) { unresolvedBodies += bodyQty; return; }
        var vid = parseInt(variantId, 10);
        // 本体が qty>1 なら同tierが台数分必要。
        perBody.push({ variantId: vid, amount: amount, years: planKey, qty: bodyQty });
        wantMap[vid] = (wantMap[vid] || 0) + bodyQty;
      });

      if (perBody.length === 0 && unresolvedBodies === 0) return null;
      return { perBody: perBody, wantMap: wantMap, unresolvedBodies: unresolvedBodies, fromCart: true };
    } catch (e) { return null; }
  }

  // ---- カート投入: Globoの /cart/add を intercept して保証variantを差し替える ----
  // 保証商品の全variant ID(数値)の集合。カート内で保証ラインを識別するのに使う。
  function warrantyVariantIdSet() {
    var s = {};
    Object.keys(CONFIG.priceMap).forEach(function (k) { s[parseInt(CONFIG.priceMap[k], 10)] = true; });
    return s;
  }

  // カートページで「これから差し替える誤tier保証行」を opacity で薄くする(文字は出さない)。
  // reload でDOMリセットされ自然に解除。正tier(差し替え不要)の行は呼ばれない=巻き込まない。
  // line index(cart.items順)から Dawn/Rise の行 #CartItem-{n} を特定。
  function dimWarrantyRowByIndex(lineIndex) {
    try {
      if (!/\/cart(\?|$|\/)/.test(location.pathname)) return; // カートページのみ
      var row = document.getElementById('CartItem-' + lineIndex) ||
                document.querySelector('[id="CartItem-' + lineIndex + '"]');
      if (!row) {
        // フォールバック: n番目のcart-item行
        var all = document.querySelectorAll('tr.cart-item, .cart-item');
        row = all[lineIndex - 1] || null;
      }
      if (row) {
        row.style.transition = 'opacity .15s';
        row.style.opacity = '0.15';
        row.style.pointerEvents = 'none';
      }
    } catch (e) {}
  }

  // ---- カート照合: Globoが投入した保証ライン(¥5,000等の固定variant)を、
  //      計算した正しいtier variant に /cart/change.js で差し替える。
  //      Globoの投入経路(fetch/GraphQL)に依存しないため、投入「後」のカート状態を直す方式。

  // ---- 保証 add 排他ロック (quickAdd と reconcile の両方から共通参照) ----
  // 同一タブ内: window.__titanWarrantyAddLock (in-memory) で同期race を遮断
  // タブまたぎ/遷移: sessionStorage('titanWarrantyAddInFlight') で永続化
  // TTL 2500ms 経過は stale として無視 (/cart/add の典型応答時間 + 余裕)
  var WARRANTY_LOCK_KEY = 'titanWarrantyAddInFlight';
  var WARRANTY_DONE_KEY = 'titanWarrantyLastAddCompletedAt';
  var WARRANTY_LOCK_TTL_MS = 2500;
  var WARRANTY_RECENT_ADD_MS = 3000;
  var _lastWarrantyAddCompletedAt = 0;
  var _qsLastAddCompletedAt = 0;

  function _readLock() {
    try {
      var inMem = window.__titanWarrantyAddLock;
      if (inMem && (Date.now() - inMem.ts) < WARRANTY_LOCK_TTL_MS) return inMem;
      var raw = sessionStorage.getItem(WARRANTY_LOCK_KEY);
      if (!raw) return null;
      var ss = JSON.parse(raw);
      if (!ss || !ss.ts || (Date.now() - ss.ts) >= WARRANTY_LOCK_TTL_MS) {
        sessionStorage.removeItem(WARRANTY_LOCK_KEY);
        return null;
      }
      return ss;
    } catch (e) { return null; }
  }
  function acquireWarrantyAddLock(variantId, source) {
    if (_readLock()) return null;
    var lock = {
      ts: Date.now(),
      variantId: String(variantId || ''),
      source: source || 'unknown',
      requestId: String(Date.now()) + '-' + Math.random().toString(36).slice(2)
    };
    window.__titanWarrantyAddLock = lock;
    try { sessionStorage.setItem(WARRANTY_LOCK_KEY, JSON.stringify(lock)); } catch (e) {}
    return lock;
  }
  function releaseWarrantyAddLock(lock) {
    if (!lock) return;
    try {
      if (window.__titanWarrantyAddLock && window.__titanWarrantyAddLock.requestId === lock.requestId) {
        window.__titanWarrantyAddLock = null;
      }
      var raw = sessionStorage.getItem(WARRANTY_LOCK_KEY);
      if (raw) {
        var cur = JSON.parse(raw);
        if (cur && cur.requestId === lock.requestId) sessionStorage.removeItem(WARRANTY_LOCK_KEY);
      }
    } catch (e) {}
  }
  function markWarrantyAddCompleted() {
    var ts = Date.now();
    _lastWarrantyAddCompletedAt = ts;
    _qsLastAddCompletedAt = ts;
    try { sessionStorage.setItem(WARRANTY_DONE_KEY, String(ts)); } catch (e) {}
  }
  function lastWarrantyAddCompletedAt() {
    var stored = 0;
    try { stored = parseInt(sessionStorage.getItem(WARRANTY_DONE_KEY) || '0', 10) || 0; } catch (e) {}
    return Math.max(_lastWarrantyAddCompletedAt || 0, _qsLastAddCompletedAt || 0, stored);
  }
  function wasWarrantyRecentlyAdded() {
    return (Date.now() - lastWarrantyAddCompletedAt()) < WARRANTY_RECENT_ADD_MS;
  }

  var _reconciling = false;
  var _lastReconcileDoneAt = 0; // 直近 reconcile 完了時刻(ms)。ポーリング監視の自己変更ガード用。
  var _rebaselineSigOnNextPoll = false; // reconcile 完了後、ポーリングが署名を強制リベースするフラグ。
  function reconcileCart() {
    if (_reconciling) return;
    // quickAdd 走行中 or 直前 3秒以内に add 完了 → 即時 reconcile は race を生む.
    // 一度 schedule に戻して quickAdd の結果がカートに反映されるのを待つ.
    if (_readLock() || wasWarrantyRecentlyAdded()) {
      scheduleReconcile();
      return;
    }
    _reconciling = true;

    var addLock = null;
    var done = function () {
      releaseWarrantyAddLock(addLock);
      _reconciling = false;
      _lastReconcileDoneAt = (Date && Date.now) ? Date.now() : 0;
      _rebaselineSigOnNextPoll = true;
      window.__titanWarrantyReconcileClean = true;
    };
    var wset = warrantyVariantIdSet();
    var doFetch = window.fetch;

    doFetch.call(window, '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) { done(); return; }
        var warrantyLines = cart.items.filter(function (it) { return wset[it.variant_id]; });
        var nonWarrantyLines = cart.items.filter(function (it) { return !wset[it.variant_id]; });
        window.__titanWarrantyCartHasWarranty = warrantyLines.length > 0;
        window.__titanWarrantyUnresolved = false;

        // 孤児チェック: 本体PCが無く保証ラインだけ残っている → 全削除。
        if (nonWarrantyLines.length === 0) {
          if (warrantyLines.length > 0) {
            chainChanges(warrantyLines.map(function (it) { return { id: it.key, quantity: 0 }; }),
              doFetch, function () { refreshCartUI(true); done(); });
          } else { done(); }
          return;
        }

        // ★希望tierの算出(複数本体対応 / 2026-06-04):
        //   本体ページ live(readRunningTotal>0)かつ本体が1台のみ → 従来 fast-path
        //   (currentWarrantySelection の live 値)を使う。
        //   それ以外(カートページ・複数本体)→ カート自身から本体ごとの正tierを派生する。
        //   いずれも最終的に「希望: variantId→必要qty」の wantMap と本体ごとの perBody を得る。
        var wantMap = {};        // { variantId(num): qty }
        var perBody = [];        // [{ variantId, amount, years, qty }...]
        var unresolvedBodies = 0;

        var liveSel = desiredWarranty(); // 商品ページなら live、cartページなら noContext
        var totalBodyQty = nonWarrantyLines.reduce(function (a, it) { return a + (it.quantity || 1); }, 0);

        if (liveSel && !liveSel.noContext && liveSel.variantId && totalBodyQty === 1) {
          // 後方互換 fast-path: 本体1台 + 商品ページ live 選択。
          var lv = parseInt(liveSel.variantId, 10);
          wantMap[lv] = 1;
          perBody.push({ variantId: lv, amount: liveSel.amount, years: liveSel.years, qty: 1 });
        } else {
          // カート派生: 本体ごとに単価×料率で個別tier。複数本体・qty統合・noContext を全て吸収。
          var derived = cartDerivedDesired(cart, wset);
          if (derived) {
            wantMap = derived.wantMap || {};
            perBody = derived.perBody || [];
            unresolvedBodies = derived.unresolvedBodies || 0;
          }
        }

        // 現状の保証ライン: variantId → [lines]。
        var haveByVariant = {};
        warrantyLines.forEach(function (it) {
          (haveByVariant[it.variant_id] = haveByVariant[it.variant_id] || []).push(it);
        });

        // 差分照合で /cart/change.js の変更リストを作る。
        //   - 希望variant: 既存qtyを希望qtyへ合わせる(不足は後で add、過剰は減量/削除)。
        //   - 希望に無いvariant(誤tier/旧tier): 全削除。
        var changes = [];
        var addQueue = []; // [{ variantId, qty, years }]

        // (1) 希望variantごとに過不足を計算。
        Object.keys(wantMap).forEach(function (vidStr) {
          var vid = parseInt(vidStr, 10);
          var wantQty = wantMap[vid];
          var lines = haveByVariant[vid] || [];
          var haveQty = lines.reduce(function (a, l) { return a + (l.quantity || 0); }, 0);
          if (haveQty === wantQty) return;            // 一致 → 何もしない
          if (haveQty > wantQty) {
            // 過剰: 先頭ラインを希望qtyに縮小、余分ラインは0削除。
            var remaining = wantQty;
            lines.forEach(function (l) {
              var give = Math.min(l.quantity || 0, remaining);
              remaining -= give;
              if (give !== (l.quantity || 0)) changes.push({ id: l.key, quantity: give });
            });
          } else {
            // 不足: 既存は維持し、差分を add する。
            // years は perBody から該当variantのものを引く(プロパティ表示用)。
            var pb = null;
            for (var i = 0; i < perBody.length; i++) { if (perBody[i].variantId === vid) { pb = perBody[i]; break; } }
            addQueue.push({ variantId: vid, qty: wantQty - haveQty, years: pb ? pb.years : null });
          }
        });

        // (2) 希望に無い保証variant(誤tier/旧tier)は全削除。
        warrantyLines.forEach(function (it, idx) {
          if (wantMap[it.variant_id]) return;
          changes.push({ id: it.key, quantity: 0 });
        });
        // 削除対象行を視覚的に薄くする(カートページのみ)。
        cart.items.forEach(function (it, idx) {
          if (wset[it.variant_id] && !wantMap[it.variant_id]) dimWarrantyRowByIndex(idx + 1);
        });

        // ★過小請求防止: プラン復元できない保証対象本体があれば未解決フラグ。
        //   さらに「保証ラインは在るのに希望が1件も立たない(=本体プラン全滅)」も未解決扱い。
        if (unresolvedBodies > 0 || (warrantyLines.length > 0 && perBody.length === 0 && Object.keys(wantMap).length === 0)) {
          window.__titanWarrantyUnresolved = true;
          try { console.warn('[TITAN-Warranty] 一部本体の保証tierを決定できず未解決。checkoutをブロックします(過小請求防止)。', { unresolvedBodies: unresolvedBodies }); } catch (e) {}
        }

        var didChange = (changes.length > 0) || (addQueue.length > 0);

        // (3) change を順に適用 → その後 add を順に適用。
        chainChanges(changes, doFetch, function () {
          if (addQueue.length === 0) { refreshCartUI(didChange); done(); return; }

          // add 群の直前ガード(race防止)。
          if (_readLock() || wasWarrantyRecentlyAdded()) { refreshCartUI(didChange); done(); return; }
          addLock = acquireWarrantyAddLock(addQueue[0].variantId, 'reconcile');
          if (!addLock) { refreshCartUI(didChange); done(); return; }

          // 直前にカート再取得し、既に必要qtyが満たされている分は add しない(二重投入防止)。
          doFetch.call(window, '/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r2) { return r2.json(); })
            .then(function (c2) {
              var have2 = {};
              (c2 && c2.items || []).forEach(function (it) {
                if (wset[it.variant_id]) have2[it.variant_id] = (have2[it.variant_id] || 0) + (it.quantity || 0);
              });
              // 必要qty - 現在qty を再計算して add 件数を確定。
              var jobs = [];
              addQueue.forEach(function (a) {
                var need = wantMap[a.variantId] - (have2[a.variantId] || 0);
                if (need > 0) jobs.push({ variantId: a.variantId, qty: need, years: a.years });
              });
              if (jobs.length === 0) { refreshCartUI(didChange); done(); return; }

              // jobs を順に /cart/add.js(qty まとめて1リクエスト/variant)。
              var j = 0;
              function nextAdd() {
                if (j >= jobs.length) { markWarrantyAddCompleted(); refreshCartUI(didChange); done(); return; }
                var job = jobs[j++];
                var props = job.years ? { '保証年数': warrantyYearsLabel(job.years) } : {};
                doFetch.call(window, '/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                  body: JSON.stringify({ id: job.variantId, quantity: job.qty, properties: props })
                }).then(function (res) {
                  if (!(res && res.ok)) {
                    try { console.warn('[TITAN-Warranty] reconcile /cart/add 失敗 HTTP', res && res.status, 'variant:', job.variantId, 'qty:', job.qty); } catch (e) {}
                  }
                  nextAdd();
                }).catch(function (err) {
                  try { console.warn('[TITAN-Warranty] reconcile /cart/add 例外:', err, 'variant:', job.variantId); } catch (e) {}
                  nextAdd();
                });
              }
              nextAdd();
            })
            .catch(function (err) {
              try { console.warn('[TITAN-Warranty] reconcile add前カート再取得失敗:', err); } catch (e) {}
              refreshCartUI(didChange); done();
            });
        });
      })
      .catch(function (err) {
        try { console.warn('[TITAN-Warranty] /cart.js 取得失敗、reconcileスキップ:', err); } catch (e) {}
        done();
      });
  }

  // 複数の /cart/change.js を順に実行
  function chainChanges(changes, fetchFn, cb) {
    if (!changes || changes.length === 0) { cb(); return; }
    var i = 0;
    function next() {
      if (i >= changes.length) { cb(); return; }
      var c = changes[i++];
      fetchFn.call(window, '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(c)
      }).then(next).catch(next);
    }
    next();
  }

  // カートUI(ドロワー/バッジ)を再描画させる。
  // 商品ページ: イベント発火で sticky/ドロワーが追従(リロード不要)。
  // カートページ: Dawn/Rise の cart-items は CustomEvent では再描画しないため、
  //   保証ラインを差し替えた時だけカート部分を更新する。
  //   ★ 旧実装は location.reload() でフルリロード(1〜2秒の体感遅延の主因)。
  //      Shopify Section Rendering API (/?sections=cart-items,cart-footer) で
  //      カート部分のHTMLだけ取得して差し替える「部分更新」に変更し、体感を激減させる。
  //      cart.json の section ID: cart-items(main-cart-items) / cart-footer(main-cart-footer)。
  function refreshCartUI(didChange) {
    try {
      document.dispatchEvent(new CustomEvent('titan:cart-warranty-updated'));
    } catch (e) {}
    var onCartPage = /\/cart(\?|$|\/)/.test(location.pathname);
    if (!didChange || !onCartPage) return;
    rerenderCartSections();
  }

  // Section Rendering API でカート部分だけ差し替える(フルリロード回避)。
  //   Dawnと同じ流儀(cart.js getSectionsToRender L122-145): 差し替えるのは各セクション内の
  //   .js-contents の innerHTML のみ。<cart-items> カスタム要素や #main-cart-items 要素自体は
  //   touch しないため、Dawn の削除/数量UIのイベントバインドが生き残る(壊さない)。
  //   セクション登録ID(cart.json): cart-items / cart-footer → DOM ID: main-cart-items / main-cart-footer。
  //   失敗時のみ従来の location.reload() にフォールバック(一度だけ・ループ防止フラグ付き)。
  // Section Rendering API は「sectionのファイル名(type値, sections/<name>.liquid のname)」
  // を要求する。cart.jsonの key("cart-items"/"cart-footer") を渡すと常に null が返り、
  // 差し替えが永久に成功しない → fallbackReload に落ちて旧5秒挙動に戻る(2026-06-02 実測判明)。
  // 正しい sectionId はテンプレートファイル名: main-cart-items / main-cart-footer / cart-icon-bubble。
  //
  // section内のswap対象セレクタについて:
  //   - main-cart-items: 「カート見出し(N点の商品)」「empty用画像」「商品テーブル」「empty時の
  //     '買い物を続ける'ボタン」など全て <cart-items class="cart-items-wrapper..."> の子に居る。
  //     .js-contents だけswapすると商品テーブル(tbody)は差し替わるが、見出しの '2点の商品' や
  //     is-empty classは古いまま残る(本体PC削除→保証孤児自動消去後に見出しが '2点' のまま
  //     『商品が無いのに2点の商品』『小計¥18,000 + 購入手続きボタン』バグになる。2026-06-02実測)。
  //     → wrapper全体(<cart-items>外側section div)を innerHTML 差し替える。
  //   - main-cart-footer: 同様に wrapper(.cart-footer-wrapper)全体を差し替える。is-empty class
  //     付与で 購入ボタン/小計/PayPal の表示制御がCSSで完結する。
  //   - cart-icon-bubble: ヘッダーのカートバッジ。別section独立。
  // ★小計ボックス消失バグ 真因修正(2026-06-04):
  //   /cart?sections=main-cart-footer の Section Rendering API レスポンスは
  //   section.blocks(subtotal/buttons)を含まず、tg-cart-footer-inner の殻だけ(256字)を返す。
  //   これで footer wrapper 全体を innerHTML 差替えすると小計/チェックアウトが消える。
  //   → footer は wrapper 全体ではなく内側の .js-contents だけを差替える(mode:'contents')。
  //     .js-contents は cart.js も差替え対象にしており、blocks 込みで正しく返る。
  //     購入ボタン(.cart__ctas, buttons block)も .js-contents の外なので wrapper 差替え不要。
  var SECTION_MAP = [
    { sectionId: 'main-cart-items', domId: 'main-cart-items', mode: 'wrapper' },
    { sectionId: 'main-cart-footer', domId: 'main-cart-footer', mode: 'contents' },
    { sectionId: 'cart-icon-bubble', domId: 'cart-icon-bubble', mode: 'wrapper' }
  ];
  function rerenderCartSections() {
    var doFetch = window.fetch;
    var ids = SECTION_MAP.map(function (m) { return m.sectionId; }).join(',');
    // Shopify Section Rendering APIは「指定URLのtemplateに含まれるsection」だけ
    // HTMLを返す。cart-items/cart-footerはcart.jsonに登録されているので /cart?sections=...
    // を叩く(/?sections=... だとTOPページにそれらsectionが無くnullが返り、ここで失敗扱い→
    // fallbackReload()が走り「5秒遅い」旧挙動に戻る。2026-06-02実測で確認)。
    // 重要: Accept ヘッダで application/json を指定すると、Shopifyは ?sections= を無視して
    // cart API(token/items/total等)を返してくる。section HTMLを得るには text/html を指定する。
    // 応答自体はContent-Type: application/json で {"main-cart-items": "<div>..."} 形式の文字列値。
    doFetch.call(window, '/cart?sections=' + ids, {
      headers: { 'Accept': 'text/html' }
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var swapped = false;
        SECTION_MAP.forEach(function (m) {
          var html = data && data[m.sectionId];
          if (typeof html !== 'string') return;
          var hostEl = document.getElementById(m.domId);
          if (!hostEl) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = html.trim();
          // Section Rendering API は <div id="shopify-section-..." class="shopify-section">
          // でラップした HTML を返す。中身の対応する DOM 要素を取り出して innerHTML 差し替え。
          var fresh = tmp.querySelector('#' + m.domId);
          if (!fresh) {
            // フォールバック: id一致が無い場合は shopify-section の中身全体
            fresh = tmp.querySelector('.shopify-section') || tmp.firstElementChild;
          }
          if (!fresh) return;
          // ★mode:'contents' (footer) は wrapper 全体でなく内側の .js-contents だけを差替える。
          //   理由: /cart?sections=main-cart-footer は section.blocks(小計/購入ボタン)を含まない
          //   殻だけを返すため、wrapper を innerHTML 差替えすると小計が消える。
          //   .js-contents は cart.js も差替え対象で、保証ライン込みの小計が正しく返る。
          //   ※ ただし sections API が blocks を含まないなら .js-contents も空で返る可能性があるため、
          //     fresh 側の .js-contents が空(中身なし)のときは差替えをスキップして現状維持する。
          if (m.mode === 'contents') {
            var freshContents = fresh.querySelector('.js-contents');
            var hostContents = hostEl.querySelector('.js-contents');
            if (freshContents && hostContents && freshContents.innerHTML.trim().length > 0) {
              hostContents.innerHTML = freshContents.innerHTML;
            }
            // footer wrapper の class / is-empty は触らない(消失バグ防止)
            return;
          }
          // <cart-items> のような外側カスタム要素そのものは保持(Dawnのイベントバインド維持)。
          // ただし中身(子DOM)とclassは差し替えて、is-empty class や見出しテキストを反映させる。
          if (hostEl.id === m.domId && fresh.id === m.domId) {
            // class属性をfreshに合わせて反映(is-emptyのトグル等)
            var freshClass = fresh.className;
            // ★小計ボックス消失バグ対策(2026-06-04):
            //   #main-cart-footer に is-empty が乗ると Dawn の
            //   `.is-empty .cart__footer{display:none}` で小計ボックスごと消える。
            //   section再描画HTMLが(タイミング次第で)空カート扱いの is-empty を含むと
            //   小計ボックスが誤って消えるため、footer wrapper には is-empty を一切付けない。
            //   真に空のときは footer 内の subtotal 等が Liquid 側で出力されないので、
            //   wrapper を表示したままでも余計なものは描画されない(安全側)。
            if (m.domId === 'main-cart-footer') {
              freshClass = freshClass.replace(/\bis-empty\b/g, '').replace(/\s+/g, ' ').trim();
            }
            hostEl.className = freshClass;
            hostEl.innerHTML = fresh.innerHTML;
          } else {
            hostEl.innerHTML = fresh.innerHTML;
          }
          swapped = true;
        });
        // <cart-items> 要素の is-empty class も実カート状態と同期させる(独立して付いてるため)。
        // Dawn cart.js:176 の挙動を再現: parsedState.item_count === 0 で is-empty 付与。
        //
        // ★小計ボックス消失バグ対策(2026-06-04):
        //   従来ここで別fetchの /cart.js を読み #main-cart-footer に is-empty を toggle していたが、
        //   保証調整中・数量変更中の「一瞬 item_count===0」を拾うと #main-cart-footer に
        //   is-empty が付き、Dawn の `.is-empty .cart__footer{display:none}`(component-cart.css L9)
        //   が誤発火 → 小計ボックスが暫くして消える事故になっていた(race condition)。
        //   footer の is-empty 制御は (a) Liquidの初期描画 + (b) 上の wrapper section 再描画(L668-674)
        //   が既に正しいHTML(=サーバ確定状態)で担当しているため、ここでの footer toggle は不要。
        //   よって #main-cart-footer への toggle は撤廃し、cart-items / cart-drawer のみ同期する
        //   (これらは商品テーブルの空表示用で、小計ボックスの表示制御には関与しない)。
        try {
          doFetch.call(window, '/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (c) {
              var isEmpty = c && c.item_count === 0;
              var ce = document.querySelector('cart-items');
              if (ce) ce.classList.toggle('is-empty', isEmpty);
              var drawer = document.querySelector('cart-drawer');
              if (drawer) drawer.classList.toggle('is-empty', isEmpty);
              // #main-cart-footer への is-empty toggle は意図的に行わない(上記コメント参照)。
              // ★小計乖離バグ 真因修正(2026-06-04):
              //   Section Rendering API の footer .js-contents が空で差替えスキップされると、
              //   reconcile で保証額が変わっても .totals__total-value(=cart.total_price)が
              //   古いまま残る。/cart.js の確定 total_price で footer/ドロワー両方を直接更新し、
              //   section swap の成否に依存せず必ず最新化する。
              if (c && typeof c.total_price === 'number') syncCartTotalText(c.total_price);
            });
        } catch (e) {}
        if (swapped) {
          // 差し替え後、構成オプションの+金額表示を再適用(新DOMには未適用のため)。
          try { applyOptionPricesToCart(); } catch (e) {}
          try { document.dispatchEvent(new CustomEvent('titan:cart-warranty-updated')); } catch (e) {}
        } else {
          fallbackReload();
        }
      })
      .catch(function (err) {
        try { console.warn('[TITAN-Warranty] section再描画に失敗、reloadにフォールバック:', err); } catch (e) {}
        fallbackReload();
      });
  }

  function fallbackReload() {
    try {
      if (!sessionStorage.getItem('titanWarrantyReloaded')) {
        sessionStorage.setItem('titanWarrantyReloaded', '1');
        location.reload();
      }
    } catch (e) {}
  }

  // /cart/add 完了を検知してカート照合を走らせる。
  // ※ window.fetch / XMLHttpRequest は絶対に wrap しない。
  //   main-product.liquid の preorder dialog が window.fetch を乗っ取って /cart/add を
  //   横取りしているため、ここで二重 wrap するとダイアログが固まる事故になる(2026-06-01)。
  //   代わりに main-product.liquid が /cart/add 成功時に出す 'titan:cart-added' イベントを購読する。
  //
  // ★Phase A最適化(2026-06-03):
  //   商品ページ上では reconcileCart() の3往復(/cart.js → /cart/change → /cart/add)を
  //   迂回し、保証variant の /cart/add.js を「直接1往復で」即時発火する。理由:
  //   - 商品ページATC直後はカート状態が単純(本体+α)で、reconcile の差し替えロジックは不要。
  //   - Globo の独自fetchは Dawn の cartUpdate を発火しない → カート画面到達後にやっと
  //     reconcile が回って保証行が遅れて出る(体感3秒)。先回りで保証を add しておけば
  //     カート画面到達時には既に完全な状態 = 体感ゼロ秒。
  //   カートページ上では従来どおり reconcileCart() を走らせる(孤児/誤tier対応のため)。
  //
  // ★DEPRECATED(2026-06-04): この関数はもう呼ばれていない(installCartWatch から外した)。
  //   理由: quickAdd は「カートに保証が無いときだけ add」する設計のため、Globo が商品ページATCで
  //   固定tier(¥5,000)保証を先に投入していると hasAnyWarranty=true で即 abort し、
  //   ¥5,000→正tier(¥61,000)の差し替えが永久に行われず過小請求になっていた。
  //   差し替え可能な reconcileCart() に一本化した。残置は将来の fast-path 再利用候補のため。
  var _qsBusy = false;
  function quickAddWarranty() {
    // L1: in-memory busy
    if (_qsBusy) return;
    // L2: クロスタブ/前ページ進行中ロック (sessionStorage)
    if (_readLock()) return;
    // L3: 直前 3秒以内に add 完了 (cartUpdate / titan:cart-added 連発の典型対策)
    if (wasWarrantyRecentlyAdded()) return;

    var sel = currentWarrantySelection();
    if (!sel || !sel.variantId) return;

    _qsBusy = true;
    var doFetch = window.fetch;
    var lock = null;
    var finalize = function () {
      releaseWarrantyAddLock(lock);
      _qsBusy = false;
    };

    // 既にカートに保証が(どのtierでも)入っていたら add しない.
    doFetch.call(window, '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var wset = warrantyVariantIdSet();
        var hasAnyWarranty = (c && c.items || []).some(function (it) { return wset[it.variant_id]; });
        if (hasAnyWarranty) return null;
        // 中間チェック: ここに来るまでに他経路が add したかも
        if (_readLock() || wasWarrantyRecentlyAdded()) return null;

        // ロック取得 (取れなければ他経路が走行中 = abort)
        lock = acquireWarrantyAddLock(sel.variantId, 'quickAdd');
        if (!lock) return null;

        // ダブルチェック: /cart/add 直前にもう一度カート確認
        return doFetch.call(window, '/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c2) {
            var has2 = (c2 && c2.items || []).some(function (it) { return wset[it.variant_id]; });
            if (has2) return null;

            return doFetch.call(window, '/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({
                id: sel.variantId,
                quantity: 1,
                properties: { '保証年数': warrantyYearsLabel(sel.years) }
              })
            }).then(function (res) {
              if (res && res.ok) {
                markWarrantyAddCompleted();
              } else {
                try { console.warn('[TITAN-Warranty] quickAdd /cart/add 失敗 HTTP', res && res.status); } catch (e) {}
              }
              return res;
            });
          });
      })
      .then(function () { finalize(); }, function (err) {
        try { console.warn('[TITAN-Warranty] quickAdd error:', err); } catch (e) {}
        finalize();
      });
  }

  // 「延長保証 選び方ガイド」を 自前構成ドロワーの延長保証セクション末尾に差し込む。
  // 自前ドロワー(tg-cust)は Liquid で render され、保証カテゴリは
  //   <section class="tg-cust__group">
  //     <header class="tg-cust__group-head">延長保証...</header>
  //     <ul class="tg-cust__options"> ...3つのli... </ul>
  //   </section>
  // という構造。<ul> の直後にガイドを差し込む。
  // (Globoの .show-addon-for-option グループは画面外に置かれてるので使えない)
  function installWarrantyGuide() {
    if (window.__titanWarrantyGuideInstalled) return;
    var tpl = document.getElementById('tg-warranty-guide-tpl');
    if (!tpl || !tpl.content) return; // template が無い商品では何もしない
    var inserted = false;
    // ヘッダのタイトルテキストだけを取り出す(子details/FAQの中身は無視).
    // tg-customize-cpu.liquid が header に <h3 class="tg-cust__group-title"> を入れている.
    function getHeaderTitle(g) {
      var titleEl = g.querySelector('.tg-cust__group-title, h3.tg-cust__group-title');
      if (titleEl) return (titleEl.textContent || '').trim();
      var head = g.querySelector('.tg-cust__group-head, header');
      if (!head) return '';
      // フォールバック: header直下のテキストノードのみ
      var t = '';
      head.childNodes.forEach(function (n) {
        if (n.nodeType === 3) t += n.textContent;
        else if (n.nodeType === 1 && !n.matches('.tg-cust__hint, details')) t += n.textContent;
      });
      return t.trim();
    }
    function tryInsert() {
      if (inserted) return true;
      var groups = document.querySelectorAll('section.tg-cust__group, .tg-cust__group');
      for (var i = 0; i < groups.length; i++) {
        var g = groups[i];
        var title = getHeaderTitle(g);
        if (!/保証|warranty/i.test(title)) continue;
        // 折りたたみ変換後はパネル内へ。変換前は他項目と同じくheaderから移動される。
        var head = g.querySelector('.tg-cust__group-head, header');
        if (g.querySelector('.tg-cust__hint')) { inserted = true; window.__titanWarrantyGuideInstalled = true; return true; }
        var panel = g.querySelector('.tg-cust__panel');
        if (panel) {
          panel.insertBefore(tpl.content.cloneNode(true), panel.firstChild);
        } else if (head) {
          head.appendChild(tpl.content.cloneNode(true));
        } else {
          g.appendChild(tpl.content.cloneNode(true));
        }
        inserted = true;
        window.__titanWarrantyGuideInstalled = true;
        return true;
      }
      return false;
    }
    if (tryInsert()) return;
    var mo = new MutationObserver(function () { if (tryInsert()) mo.disconnect(); });
    mo.observe(document.body, { childList: true, subtree: true });
    // 安全装置: 15秒後に諦める
    setTimeout(function () { mo.disconnect(); }, 15000);
  }

  // 8カテゴリ選び方ガイド (CPU/メモリ/マザボ/SSD/クーラー/電源/無線/出荷前) を
  // 自前構成ドロワー (tg-cust__group) の対応するセクション末尾に挿入する。
  // 各 details[data-cat] を tpl から切り出し、ヘッダのテキストを照合.
  function installCatGuides() {
    if (window.__titanCatGuidesInstalled) return;
    var tpl = document.getElementById('tg-cat-guides-tpl');
    if (!tpl || !tpl.content) return;
    // data-cat → ヘッダ照合の正規表現
    // 注意: 順番が重要。tg-cust の既存ヘッダは
    // 「CPU選び方ガイド...」「CPUクーラー選び方ガイド...」のように複合になっているので、
    // より長い文字列 (CPUクーラー) を CPU より先に判定する。
    var CATS = [
      { cat: 'cooler',      re: /CPU\s*クーラー/ },
      { cat: 'cpu',         re: /^CPU(?!クーラー)/i },
      { cat: 'memory',      re: /メモリ/ },
      { cat: 'motherboard', re: /マザーボード/ },
      { cat: 'ssd',         re: /^SSD/i },
      { cat: 'psu',         re: /^電源/ },
      { cat: 'wifi',        re: /無線|Wifi|Wi-?Fi/i },
      { cat: 'setup',       re: /出荷前セットアップ/ }
    ];
    var inserted = {};
    function tryInsertAll() {
      var groups = document.querySelectorAll('section.tg-cust__group, .tg-cust__group');
      var allDone = true;
      for (var c = 0; c < CATS.length; c++) {
        var cat = CATS[c];
        if (inserted[cat.cat]) continue;
        var placed = false;
        for (var i = 0; i < groups.length; i++) {
          var g = groups[i];
          var head = g.querySelector('.tg-cust__group-head, header');
          if (!head) continue;
          var ht = (head.textContent || '').trim();
          if (!cat.re.test(ht)) continue;
          if (g.querySelector('.tg-cat-guide[data-cat="' + cat.cat + '"]')) {
            inserted[cat.cat] = true; placed = true; break;
          }
          // tpl から該当 details を取り出して append
          var src = tpl.content.querySelector('details[data-cat="' + cat.cat + '"]');
          if (!src) { inserted[cat.cat] = true; placed = true; break; }
          var clone = src.cloneNode(true);
          g.appendChild(clone);
          inserted[cat.cat] = true; placed = true;
          break;
        }
        if (!placed) allDone = false;
      }
      return allDone;
    }
    if (tryInsertAll()) { window.__titanCatGuidesInstalled = true; return; }
    var mo = new MutationObserver(function () {
      if (tryInsertAll()) { window.__titanCatGuidesInstalled = true; mo.disconnect(); }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }

  function installCartWatch() {
    if (window.__titanWarrantyWatch) return;
    window.__titanWarrantyWatch = true;
    var _lastEventTs = 0;
    document.addEventListener('titan:cart-added', function () {
      // 同期 dedup: main-product.liquid の2箇所が同じ ATC 成功で
      // 立て続けに dispatch するケースに対応 (200ms 以内の連発は1回として扱う)
      var now = Date.now();
      if (now - _lastEventTs < 200) return;
      _lastEventTs = now;

      // ★真因修正(2026-06-04): 商品ページでも reconcileCart() を走らせる。
      //   旧実装は商品ページで quickAddWarranty() を呼んでいたが、quickAdd は
      //   「カートに保証が1つも無いときだけ add する」設計(L791 hasAnyWarranty で abort)。
      //   Globo は商品ページATCで固定tier(¥5,000)保証を既にカート投入済みなので
      //   hasAnyWarranty=true → quickAdd は即 return し、¥5,000→正tier(¥61,000)の
      //   差し替えが永久に行われなかった(カート小計が保証¥5,000のまま=過小請求)。
      //   reconcileCart() は誤tier保証ラインを正tierに差し替える唯一の経路なので、
      //   商品ページでもこれを使う。商品ページでは readRunningTotal()>0 のため
      //   desiredWarranty() が live の currentWarrantySelection()(=正しい¥61,000 tier)を
      //   返し、sessionStorage に依存せず確実に差し替わる。
      scheduleReconcile();
    });
    log('cart watch installed (event: titan:cart-added)');
  }

  // 連続投入でreconcileが多重に走らないようにデバウンス。
  // 商品ページ: Globoが固定tier投入→イベント連発しうるので 400ms まとめる。
  // カートページ: 既に投入済みで連発しないため待つ意味がなく、体感遅延の元。短く(60ms)する。
  var _recTimer = null;
  function scheduleReconcile() {
    var onCartPage = /\/cart(\?|$|\/)/.test(location.pathname);
    var delay = onCartPage ? 60 : 400;
    if (_recTimer) clearTimeout(_recTimer);
    _recTimer = setTimeout(function () { _recTimer = null; reconcileCart(); }, delay);
  }

  // ---- 監視: 総額変動・チェック変更で再計算 ----
  function observe() {
    var mainEl = document.querySelector('.titan-price-main');
    if (mainEl) {
      new MutationObserver(function () { updateDisplay(); })
        .observe(mainEl, { childList: true, characterData: true, subtree: true });
    }
    // 保証オプションの change（ラジオ/チェックボックス両対応・value/labelで判定）
    document.addEventListener('change', function (e) {
      var el = e.target;
      if (el && el.matches && el.matches('input[type="radio"], input[type="checkbox"]')) {
        if (/保証|warranty/i.test(warrantyTextOf(el))) {
          updateDisplay();
        }
      }
    }, true);
    // Globoが後から要素を差し込むので定期再評価(初期だけ)
    var n = 0;
    var t = setInterval(function () { updateDisplay(); if (++n > 20) clearInterval(t); }, 500);
  }

  // カートページ / カートドロワー表示時にも reconcile を走らせる(投入経路を取りこぼした場合の保険)。
  // 商品ページ以外でもこのJSが読まれた場合に効くよう、cart関連DOMの出現を監視。
  // カートの本体構成スペック行に、保存した差額マップから「+¥15,000」を差し込む。
  // .tg-cart-spec の <dd>(値) を titanOptPriceMap と照合。差額>0のものだけ付ける。
  function applyOptionPricesToCart() {
    try {
      if (!/\/cart(\?|$|\/)/.test(location.pathname)) return;
      var raw = sessionStorage.getItem('titanOptPriceMap');
      if (!raw) return;
      var data = JSON.parse(raw);
      var map = (data && data.map) || {};
      var specs = document.querySelectorAll('.tg-cart-spec');
      [].forEach.call(specs, function (spec) {
        if (spec.getAttribute('data-titan-priced') === '1') return; // 二重付与防止
        if (spec.classList.contains('tg-cart-spec--warranty')) return; // 保証は別途+¥を出してる
        var dd = spec.querySelector('dd');
        if (!dd) return;
        var val = (dd.textContent || '').trim();
        var addon = map[val];
        if (addon && addon > 0) {
          var s = document.createElement('span');
          s.className = 'tg-cart-spec__addon';
          s.textContent = ' +¥' + addon.toLocaleString('ja-JP');
          dd.appendChild(s);
          spec.setAttribute('data-titan-priced', '1');
        }
      });
    } catch (e) {}
  }

  function installCartViewWatch() {
    var ran = false;
    function tryReconcile() { scheduleReconcile(); }
    // 1) カートページなら即時 reconcile + 構成差額表示。
    if (/\/cart(\?|$|\/)/.test(location.pathname)) { tryReconcile(); applyOptionPricesToCart(); ran = true; }
    // 2) カートドロワー(Dawn: cart-drawer)が開いたら
    var drawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
    if (drawer) {
      new MutationObserver(function () {
        var open = drawer.classList.contains('active') || drawer.classList.contains('is-open') ||
                   drawer.getAttribute('aria-hidden') === 'false';
        if (open) tryReconcile();
      }).observe(drawer, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
    }
    // 3) 標準カートイベント
    document.addEventListener('cart:refresh', tryReconcile);
    document.addEventListener('cart:updated', tryReconcile);

    // 3.5) 本体PC削除/数量変更を検知して reconcile(孤児削除/tier差し替え)を起動する。
    //   旧実装(tbody MutationObserver)は壊れていた:
    //     Dawnの削除は /cart/change.js 後に .js-contents の innerHTML を丸ごと差し替える(cart.js L183-190)。
    //     tbody はその内側なので破棄・再生成され、初期化時に掴んだ tbody への observer は stale 化し
    //     二度と発火しない。本体削除が検知されず reconcile が走らず、保証だけ孤児として残っていた。
    //   正しい方法 = Dawn が削除/数量変更/クリア成功後に必ず出す正規シグナル
    //     publish(PUB_SUB_EVENTS.cartUpdate)(cart.js L217)を subscribe で購読する。
    //     これは pubsub.js の独自 pub/sub であり document の CustomEvent ではない(L596-597 では捕れない)。
    //     購読は read-only で fetch を一切触らないため preorder dialog の fetch 乗っ取りと競合しない。
    //   ロード順(theme.liquid: constants 57 → pubsub 58 → warranty 71, 全 defer)で
    //     subscribe(function宣言=global) と PUB_SUB_EVENTS(const=lexical global) は参照可能。
    var _dawnSub = (typeof subscribe === 'function') ? subscribe
                 : (typeof window.subscribe === 'function' ? window.subscribe : null);
    var _dawnEvents = (typeof PUB_SUB_EVENTS !== 'undefined') ? PUB_SUB_EVENTS
                    : (window.PUB_SUB_EVENTS || null);
    if (_dawnSub && _dawnEvents && _dawnEvents.cartUpdate) {
      _dawnSub(_dawnEvents.cartUpdate, function (event) {
        // 自前 reconcile の /cart/add・/cart/change は素の window.fetch 直叩きで
        // Dawn CartItems を経由しないため cartUpdate を publish せず、自己トリガーしない。
        // 念のため source 比較も入れておく(自分由来は無視)。
        if (event && event.source === 'titan-warranty') return;
        tryReconcile();
      });
      log('cart watch installed (pubsub: cartUpdate)');
    } else {
      // フォールバック: pubsub が無いテーマ構成のみ。tbody でなく .js-contents
      //   (innerHTML 差し替えの対象=要素自体は生存)を subtree 監視する。
      var jsContents = document.querySelector('.cart-items .js-contents, cart-items .js-contents');
      if (jsContents) {
        new MutationObserver(function () { tryReconcile(); })
          .observe(jsContents, { childList: true, subtree: true });
        log('cart watch installed (fallback: .js-contents observer)');
      }
    }

    // 3.6) ★過小請求の最終防波堤(2026-06-04): カートページ限定の cart 状態ポーリング監視。
    //   背景: Dawn標準の数量変更(quantity-input → CartItems.updateQuantity → publish(cartUpdate))は
    //     上の pubsub 購読(3.5)で捕捉できるが、Globo Product Options で大量オプションを焼いた本体行は
    //     数量変更を独自AJAX/独自DOM差し替え/直 /cart/change.js で処理し、Dawnの cartUpdate を
    //     publish せず迂回することがある。その結果「本体だけ数量2、保証は1口のまま」reconcile が
    //     走らず過小請求になる(Image #89 / 実ライブ確認 2026-06-04)。
    //   対策: 投入経路・イベントに一切依存せず、カートの真実(/cart.js)を定期ポーリングして
    //     「行構成(variant_id × quantity)の署名」が変わったら reconcile を起動する。
    //     read-only の GET /cart.js のみで fetch は一切 wrap しない(preorder dialog の fetch 乗っ取り事故回避)。
    //   コストは GET /cart.js を ~1.5s 間隔の軽量ポーリング。カートページ表示中のみ・離脱で停止。
    if (/\/cart(\?|$|\/)/.test(location.pathname) && !window.__titanCartPollInstalled) {
      window.__titanCartPollInstalled = true; // 二重設置ガード(再呼出しで interval が増殖しないように)
      var _cartSig = null;
      var _sigDoFetch = window.fetch; // 素の fetch を直接参照(wrap しない/されない)
      function cartSignature(cart) {
        if (!cart || !cart.items) return '';
        // 行順は Shopify が保証しない(add行は末尾追加等)。順序ノイズで誤発火しないよう
        //   variant_id:qty をソートして安定署名にする。
        return cart.items.map(function (it) {
          return it.variant_id + ':' + (it.quantity || 0);
        }).sort().join('|') + '#' + (cart.item_count || 0);
      }
      // 自己ループ防止(二段構え):
      //   (a) reconcile 進行中(_reconciling)、または直近完了から SELF_WINDOW_MS 以内の変化は
      //       「自分の add/change による変化」とみなし、署名だけ追従して再 reconcile しない。
      //   (b) reconcile 完了時(done)に _reconcileSettledSig をクリアしておき、完了後に最初に観測した
      //       cart 署名をその回の「自己変更後の正規ベースライン」として強制採用する。これにより
      //       reconcile が SELF_WINDOW_MS を超える遅い環境でも、自分の変更を外部変更と誤検知して
      //       余分な reconcile(過大請求側)を打つことを防ぐ。
      //   外部要因(ユーザー操作/Globo経由の数量変更)による署名変化のみ reconcile を起動する。
      var SELF_WINDOW_MS = 4000;
      function pollCartState() {
        _sigDoFetch.call(window, '/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var sig = cartSignature(cart);
            if (_cartSig === null) { _cartSig = sig; return; } // 初回はベースライン記録のみ

            // (b) reconcile 完了直後の最初の観測 → 自己変更後の署名を無条件でベースライン化。
            if (_rebaselineSigOnNextPoll) {
              _rebaselineSigOnNextPoll = false;
              _cartSig = sig;
              return;
            }
            if (sig === _cartSig) return;                       // 変化なし

            var now = (Date && Date.now) ? Date.now() : 0;
            var selfBusy = _reconciling || (now - _lastReconcileDoneAt < SELF_WINDOW_MS);
            _cartSig = sig; // どちらでも署名は最新化(変化を1度だけ評価)
            if (selfBusy) return; // 自分由来 → 何もしない
            // 外部要因 → 過小請求の恐れ。reconcile 起動。
            window.__titanWarrantyReconcileClean = false;
            tryReconcile();
          })
          .catch(function () {});
      }
      var _cartPollTimer = setInterval(pollCartState, 1500);
      // ページ離脱で停止(SPAではないが保険)。
      window.addEventListener('pagehide', function () { clearInterval(_cartPollTimer); });
      log('cart watch installed (poll: /cart.js signature)');
    }

    // 4) checkout手前ガード: 保証reconcile未完のまま checkout/購入手続きへ抜けるのを防ぐ。
    //    カートページ・ドロワーの「購入手続きへ」、Shop Pay等の動的決済ボタンを捕捉し、
    //    希望保証があるのに reconcile 未完なら、一旦遷移を止めて reconcile → 完了後に再クリック。
    installCheckoutGuard();
    return ran;
  }

  var _checkoutGuardArmed = false;
  function installCheckoutGuard() {
    if (_checkoutGuardArmed) return;
    _checkoutGuardArmed = true;
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest(
        'button[name="checkout"], [name="checkout"], .cart__checkout-button, ' +
        'a[href*="/checkout"], .shopify-payment-button button, .shopify-payment-button__button');
      if (!t) return;
      // 直近 reconcile 完了済みなら通す
      if (window.__titanWarrantyReconcileClean) return;
      // 止める条件:
      //   (a) 希望保証がある(sessionStorage/商品ページ選択あり) → 正tierに差し替えるまで待つ
      //   (b) sessionStorage が空でも、カートに保証ライン(誤tierの可能性)が現存する
      //       → reconcile が cartDerivedDesired() で正tierに直すまで待つ(過小請求の流出防止)
      //   どちらも無ければ保証は無関係なので通す。
      var sel = desiredWarranty();
      var hasDesired = !!(sel && sel.variantId);
      var cartHasWarranty = window.__titanWarrantyCartHasWarranty === true;
      if (!hasDesired && !cartHasWarranty) return;
      // ここまで来たら「保証要差し替え・reconcile未完」→ 一旦止めて差し替えを走らせる
      e.preventDefault();
      e.stopImmediatePropagation();
      scheduleReconcile();
      // reconcile(400ms debounce + 非同期3往復)完了を見込んで再クリック。
      // clean が立つまで最大数回リトライ。
      var tries = 0;
      var retry = setInterval(function () {
        tries++;
        var clean = window.__titanWarrantyReconcileClean;
        var unresolved = window.__titanWarrantyUnresolved === true;
        // 過小請求防止: 正tierを決定できない(unresolved)まま checkout を通さない。
        //   reconcile が clean になっても unresolved の場合は誤tierが残っている可能性 → ブロック継続。
        //   ユーザーに保証を選び直す/外すよう促し、自動 click-through はしない。
        if (clean && !unresolved) {
          clearInterval(retry);
          try { t.click(); } catch (err) { if (t.href) location.href = t.href; }
          return;
        }
        if (tries >= 8) {
          clearInterval(retry);
          if (unresolved) {
            try {
              window.alert('延長保証の金額を確定できませんでした。お手数ですが、カートの延長保証を一度削除し、商品ページで保証を選び直してください。（過大・過小請求防止のため購入手続きを一時停止しています）');
            } catch (e) {}
            // 自動で checkout には進めない(過小請求の流出を防ぐ)。
          } else {
            // unresolved ではない(=保証無関係 or 既に正tier)なら通常どおり通す。
            try { t.click(); } catch (err2) { if (t.href) location.href = t.href; }
          }
        }
      }, 250);
    }, true);
  }

  function init() {
    // 商品ページに居る時だけ reload 一回フラグをクリア(次にカートで差し替えたら再度reload可)。
    // カートページでクリアすると reconcile→reload→クリア の無限ループになるのでしない。
    try {
      if (document.querySelector('.titan-price-main')) {
        sessionStorage.removeItem('titanWarrantyReloaded');
      }
    } catch (e) {}
    updateDisplay();
    observe();
    installCartViewWatch();
    installWarrantyGuide();
    installCatGuides();
    // カートページ: reconcileのreloadやセクション再描画後にも差額を差し込めるよう、遅延で再実行。
    if (/\/cart(\?|$|\/)/.test(location.pathname)) {
      setTimeout(applyOptionPricesToCart, 800);
      setTimeout(applyOptionPricesToCart, 2000);
    }
    log('init done');
  }

  // カート監視を即時インストール('titan:cart-added' イベント購読)。
  // 投入完了後に reconcileCart() で保証ラインを正しいtierに差し替える。
  installCartWatch();

  // 起動待ち: 商品ページは Globo のラジオ描画を待つため 600ms。
  // カートページはラジオを待つ必要がなく(既に投入済みの保証を即照合したい)、待ちは体感遅延の元。
  // → カートページは待ちなし(0ms)で init して即 reconcile に入れる。
  var _initDelay = /\/cart(\?|$|\/)/.test(location.pathname) ? 0 : 600;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, _initDelay); });
  } else {
    setTimeout(init, _initDelay);
  }
})();
